
<template>
    <section>
    </section>
</template>

<script>
import monitor from "@/assets/js/monitor";

export default {
  data() {
    return {};
  },
  mounted() {
    var me = this;

    // $(".track").click(function(e) {
    //   // console.log("maidian==="+e.target.innerHTML);
    //   monitor.TrackClick($(this).attr("trackname"));
    // });
    // //只有在页面跳转才会触发
    // var url = "";
    // var referrer = "";
    // this.$router.beforeEach((to, from, next) => {
    //   url = to.path;
    //   referrer = from.path;
    //   next();
    // });

    // if (url == "") {
    //   url = window.location.pathname;
    //   referrer = url;
    // }

    // monitor.url = url;
    // monitor.referrer = referrer;

    // var obj = {
    //   app: 140,
    //   memberCode: localStorage.getItem("phone"),
    //   onlineId: sessionStorage.getItem("token"),
    //   businessId: "",
    //   shopMemberCode: "",
    //   productLine: "140",
    //   clientType: "5",
    //   version: "v1.0",
    //   deploymentEnvironment: "1"
    // };

    // try {
    //   monitor._monitorModel = obj;
    //   monitor.LoadPage();
    // } catch (error) {}
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/c-monitor.vue